import Modal from 'react-modal';

const modalize =
  ({ contentLabel = '', className = '' }) =>
  (ComposedComponent) => {
    const ModalizeComponent = (props) => {
      const {
        onRequestClose = () => {},
        onCancel = () => {},
        onAccept = () => {},
        ...otherProps
      } = props;

      const handleAccept = () => {
        onRequestClose();
        if (onAccept) {
          onAccept();
        }
      };

      let handleCancel;

      if (onCancel) {
        handleCancel = () => {
          onRequestClose();
          onCancel();
        };
      } else {
        handleCancel = handleAccept;
      }

      return (
        <Modal
          onRequestClose={handleCancel}
          className={`modal ${className}`}
          contentLabel={contentLabel}
          {...otherProps}
        >
          <ComposedComponent
            onRequestClose={handleCancel}
            onAccept={handleAccept}
            {...otherProps}
          />
        </Modal>
      );
    };

    return ModalizeComponent;
  };

export default modalize;
